import Footer from "components/sections/footer"
import Header from "components/sections/headerV2"
import Seo from "components/sections/seo"
import { graphql } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import { getArticleSchema, getSchemaWithFallback } from "../../utils/schemaHelpers"
import Template, { LearnTemplatDetailsProps } from "./template"

const TemplateContainer = ({
  data: { careNote, footer, header, template },
}) => {
  const fallbackSchema = getArticleSchema(careNote)
  
  // Use Contentful json if present, otherwise use fallback
  const schema = getSchemaWithFallback(careNote.meta?.json, fallbackSchema)

  return (
    <>
      <Seo
        {...careNote.meta}
        id={careNote.id}
        schemaMarkup={schema}
        slug={`${template.slugPrefix}/${careNote.slug}`}
      />
      <Header {...header} />
      <Template {...template} careNote={careNote} />
      <Footer {...footer} />
    </>
  )
}

TemplateContainer.props = {
  ...LearnTemplatDetailsProps,
  meta: PropTypes.shape(Seo.props),
}

TemplateContainer.propTypes = {
  data: PropTypes.shape({
    careNote: PropTypes.shape(TemplateContainer.props),
    footer: PropTypes.shape(Footer.props),
    header: PropTypes.shape(Header.props),
    template: PropTypes.shape(Template.props),
  }),
}

export default TemplateContainer

export const query = graphql`
  fragment ButtonV2Fields on ContentfulComponentButtonV2 {
    id
    accessibilityLabel
    showArrow
    buttonSize
    buttonStyle
    path
    text
  }
  fragment ImageFields on ContentfulAsset {
    title
    description
    file {
      url
    }
  }
  query CareNote($slug: String) {
    header: contentfulGlobalHeader(name: { eq: "Header" }) {
      announcement {
        json
      }
      menu {
        menus {
          label
          links {
            text
            path
            nestedLinks {
              text
              path
            }
          }
        }
      }
      utilityLinks {
        path
        text
      }
      cta {
        href: path
        text
      }
      callsToAction {
        ...ButtonV2Fields
      }
    }
    footer: contentfulGlobalFooter(name: { eq: "Footer" }) {
      menu {
        menus {
          label
          links {
            path
            text
          }
        }
      }
      scheduleAppointment {
        path
        text
      }
      socialLinks {
        path
        text
      }
      utilityLinks {
        path
        text
      }
    }
    careNote: contentfulCareNote(slug: { eq: $slug }) {
      createdAt
      slug
      title
      authors {
        department
        name
        slug
        picture {
          title
          fluid(maxHeight: 200, maxWidth: 200, quality: 90) {
            src
          }
        }
      }
      category {
        id
        name
        theme
      }
      details {
        json
      }
      resources {
        id
        slug
        title
        category {
          id
          name
          theme
        }
      }
      meta: seoMetadata {
        canonical
        keywords
        title
        type
        abstract {
          abstract
        }
        description {
          description
        }
        image {
          file {
            url
          }
        }
      }
    }
    template: contentfulWebPageTemplate(model: { eq: "Care Note" }) {
      slugPrefix
      title
      sections {
        __typename
        ... on ContentfulTemplateSection {
          __typename
          title
        }
      }
    }
  }
`
